import { trackClientEvent } from '../../../../trackClientEvent';
export var eventKey = 'zip_code_protection-brand_blocked-action_unknown';
/**
 * Retailer was blocked from making a purchase due to zip code protection. This logs the blocked brand token and the reason
 */ export function trackZipCodeProtectionBrandBlocked(brandToken, Blocked_reason_code) {
    return trackClientEvent({
        eventKey: eventKey,
        realTimeTracking: false,
        parameters: {
            brandToken: brandToken,
            Blocked_reason_code: Blocked_reason_code
        }
    });
}
